/** @jsx h */
import { h } from 'preact'
import ProofPointStatus from '../ProofPointStatus'
import { track } from '../../../utils/analytics'
import DefaultIcon from '../../../../assets/images/svgs/icon-scheme-default.svg'

const ProofPoint = ({ id, type, name, iconSvg, logoUrl, onClick, analyticsContext, claimStatus }) => {
  const icon = iconSvg
    ? <div dangerouslySetInnerHTML={{ __html: iconSvg }} />
    : logoUrl
      ? <img src={logoUrl} alt='' width='44' height='44' />
      : <img src={DefaultIcon} alt='' width='44' height='44' />

  const iconClass = type === 'Claim' ? type.toLowerCase() : 'scheme'

  const proofPointClicked = e => {
    if (typeof onClick === 'function') {
      onClick(id)
    }
    track('click_proofpoint_modal', {
      eventAction: name,
      eventLabel: analyticsContext
    })
  }

  return (
    <div
      class='Capsule'
      onClick={proofPointClicked}
    >
      <div
        class={`Capsule-icon Capsule-icon--${iconClass}`}
      >
        {icon}
      </div>
      <div class='Capsule-details'>
        <div class='Capsule-category'>{name}</div>
        <ProofPointStatus status={claimStatus} />
      </div>
    </div>
  )
}

ProofPoint.defaultProps = {
  type: 'scheme',
  ipfsHash: '',
  iconSvg: null,
  logoUrl: ''
}

export default ProofPoint
